import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { SanitizeHTML } from 'ui-components/common/SanitizeHTML';
import { getCoverImageBorder, getCoverImageStyle } from 'styles/common';

export const Container = styled.div<{ disabled?: boolean }>`
  display: flex;
  position: relative;
  padding: 16px 0;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

export const EmptyRightSection = styled.div`
  flex-grow: 1;
  align-self: center;
`;

export const LeftCoverSection = styled.div`
  position: relative;
  width: 56px;
  height: 86px;
  flex-shrink: 0;
  margin-right: 16px;
`;

export const LeftIconSection = styled.div`
  position: relative;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  margin-right: 16px;
`;

export const RightSection = styled.div`
  flex-grow: 1;
`;

export const CoverWrapper = styled.div`
  ${getCoverImageBorder()};
  height: 100%;
  position: relative;
  border-radius: 3px;

  & > img {
    ${getCoverImageStyle()}
  }
`;

export const Unread = styled.div(
  ({ isRead }: { isRead: boolean }) => css`
    position: absolute;
    width: 6px;
    height: 6px;
    background-color: ${Color.Red500};
    border-radius: 50%;
    left: -10px;
    top: 50%;
    transform: translateY(-50%);
    opacity: ${isRead ? 0 : 1};
    transition: opacity 0.2s ease-in-out;
  `,
);

export const TitleWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const SanitizeHTMLTitle = styled(SanitizeHTML)<{ opacity?: number }>`
  ${Typography.XSmall}
  text-align: left;
  color: rgba(0, 0, 0, ${({ opacity }) => opacity ?? 1});

  & > .inbox-title-date {
    ${Typography.XXSmall}
    font-weight: ${FontWeight.Regular};
    color: ${Color.Gray500};
    margin-left: 4px;
  }
`;

export const Extra = styled.div`
  margin-top: 8px;
`;
